import * as Sentry from "@sentry/react";
import { getFromLocalStorage } from "./utils/localStorageHelpers";
import { getPlatform } from "./analytics";
import { servicesList } from "./config/Services";

export const captureApiError = (error, apiPath) => {
  const statusCode = error?.response?.status || error?.status || "unknown";
  const responseData = error?.response?.data || {};
  let errorMessage = "";

  if (typeof responseData === "object" && responseData?.message) {
    //if message is an object , extract its properities
    if (typeof responseData?.message === "object") {
      errorMessage = responseData?.message?.error || JSON.stringify(responseData?.message);
    } else {
      errorMessage = responseData?.message;
    }
  } else if (typeof responseData === "string") {
    errorMessage = responseData;
  }
  const locId = getFromLocalStorage("locId") || "NA";
  const locName = getFromLocalStorage("LocName") || "NA";

  const service = getServiceFromEndPoint(apiPath);
  Sentry.captureException(error, {
    tags: {
      api_path: apiPath,
      service,
      locId,
      locName,
      platform: getPlatform(),
      status_code: statusCode,
    },
    extra: {
      response_data: responseData,
    },
  });
};

export const captureCustom200Error = (responseData, endpoint) => {
  const locId = getFromLocalStorage("locId") || "NA";
  const locName = getFromLocalStorage("LocName") || "NA";
  const service = getServiceFromEndPoint(endpoint);

  // Capture the 200 error with specific message for Sentry filtering
  Sentry.captureEvent({
    message: `Es error: ${
      responseData?.message ||
      (responseData?.data && responseData?.data?.message) ||
      "No message available"
    }`,
    level: "error",
    tags: {
      api_path: endpoint,
      service,
      locId,
      locName,
      platform: getPlatform(),
      status_code: 200,
    },
    extra: {
      response_data: responseData,
    },
  });
};

//finding exact service path so sentry gives us proper information
export const getServiceFromEndPoint = (endpoint) => {
  if (!servicesList || typeof servicesList !== "object") {
    console.warn("servicesList is undefined or not an object");
    return "unknown";
  }
  for (const [serviceKey, servicePath] of Object.entries(servicesList)) {
    if (endpoint.includes(`/${servicePath}`)) {
      //Returns the key from servicesList that matches
      return servicePath;
    }
  }
  return "unknown";
};
